import { createFileRoute } from '@tanstack/react-router'
import { SupplierRefundPrintPage } from '../../../../features/purchasing/voucher-print-pages'
import { voucherPrintSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/supplier-refunds/$refundId/print')({
  staticData: { crumb: 'purchasePrint' },
  validateSearch: voucherPrintSearchSchema,
  component: SupplierRefundPrintPage,
})
